import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      mixin_filters: {
        groups: {
          'common': {
            name: 'Common:',
            fields: {
              'date_from': {
                type: 'datepicker',
                name: 'date_from',
                label: 'Month from',
                format: 'MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: moment().subtract(1, 'months').startOf('month').toISOString(),
                class: 'col-md-2',
                group: 'common',
                minimumView: 'month'
              },
              'date_to': {
                type: 'datepicker',
                name: 'date_to',
                label: 'Month to',
                format: 'MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: moment().subtract(1, 'months').endOf('month').toISOString(),
                class: 'col-md-2',
                group: 'common',
                minimumView: 'month'
              }
            }
          },
          'payouts': {
            name: 'Payouts:',
            fields: {
              'contractors': {
                type: 'multiselect',
                name: 'contractors',
                nameItem: 'user_id',
                label: 'Payout contractors',
                valueField: 'id',
                selectLabel: 'label',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'payouts'
              },
              'partners': {
                type: 'multiselect',
                name: 'partners',
                nameItem: 'partner_id',
                label: 'Payout partners',
                selectLabel: 'company_name',
                valueField: 'id',
                allowEmpty: true,
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'payouts'
              },
              'payout_statuses': {
                type: 'multiselect',
                name: 'payout_statuses',
                nameItem: 'payout_status_id',
                label: 'Payout statuses',
                valueField: 'id',
                selectLabel: 'name',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'payouts'
              }
            }
          },
          'expenses': {
            name: 'Expenses:',
            fields: {
              'expenses_users': {
                type: 'multiselect',
                name: 'expenses_users',
                nameItem: 'user_id',
                label: 'Expenses users',
                valueField: 'id',
                selectLabel: 'label',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'expenses'
              },
              'expenses_statuses': {
                type: 'multiselect',
                name: 'expenses_statuses',
                nameItem: 'expense_status_id',
                label: 'Expenses statuses',
                valueField: 'id',
                selectLabel: 'display_name',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'expenses'
              },
              'expenses_categories': {
                type: 'multiselect',
                name: 'expenses_categories',
                nameItem: 'expense_category_id',
                label: 'Expenses categories',
                valueField: 'id',
                selectLabel: 'display_name',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'expenses'
              }
            }
          },
          'invoices': {
            name: 'Invoices:',
            fields: {
              'business_developers': {
                type: 'multiselect',
                name: 'business_developers',
                nameItem: 'business_developer_id',
                label: 'Invoices business developers',
                valueField: 'id',
                selectLabel: 'label',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'invoices'
              },
              'invoice_statuses': {
                type: 'multiselect',
                name: 'invoice_statuses',
                nameItem: 'invoice_status_id',
                label: 'Invoices statuses',
                valueField: 'id',
                selectLabel: 'display_name',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'invoices'
              },
              'projects': {
                type: 'multiselect',
                name: 'projects',
                nameItem: 'project_id',
                label: 'Invoices projects',
                valueField: 'id',
                selectLabel: 'label',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'invoices'
              },
              'types': {
                type: 'multiselect',
                name: 'invoice_types',
                nameItem: 'invoice_type_id',
                label: 'Invoices types',
                valueField: 'id',
                selectLabel: 'type',
                options: [],
                value: [],
                class: 'col-md-3',
                group: 'invoices'
              }
            }
          }
        }
      },
      mixin_tableRowModal: {
        show: false,
        items: null,
        title: null,
        fields: [
          {
            key: 'own_bank_details.summary',
            label: 'Own Bank Details'
          },
          {
            key: 'project.name',
            label: 'Project Name'
          },
          {
            key: 'client_bank_details.summary',
            label: 'Client Bank Details'
          },
          {
            key: 'invoice_status.name',
            label: 'Invoice Status'
          },
          {
            key: 'invoice_template_type.name',
            label: 'Invoice Template Type'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'comment_national',
            label: 'Comment national'
          },
          {
            key: 'issue_date',
            label: 'Issue Date'
          },
          {
            key: 'due_date',
            label: 'Due Date'
          },
          {
            key: 'invoice_type.type',
            label: 'Invoice Type'
          },
          {
            key: 'client_bank_details',
            type: 'slot',
            label: 'Client name',
            slotName: 'client_name'
          },
          {
            key: 'total_amount',
            label: 'Total Amount'
          },
          {
            key: 'periods',
            type: 'slot',
            label: 'Periods',
            slotName: 'periods'
          },
          {
            key: 'items',
            type: 'slot',
            label: 'Items',
            slotName: 'items'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      _getProjects: 'projects/getProjects',
      _getAllUsers: 'getAllUsers',
      _getAllPartners: 'partners/getAllPartners',
      _getStatuses: 'finances/getStatuses',
      _getBusinessDevelopers: 'businessDevelopers/getBusinessDevelopers',
      _getInvoicesTypes: 'finances/getInvoicesTypes',
      _getExpensesStatuses: 'getExpensesStatuses',
      _getExpensesCategories: 'getExpensesCategories'
    })
  },
  methods: {
    _getClassByPercent (percent) {
      if (percent > 25) return 'green'
      if (percent < 0) return 'red'
      if (percent <= 25) return 'yellow'
    },
    _fetchAllData () {
      Promise.all([
        this._fetchAllUsers(),
        this._fetchAllPartners(),
        this._fetchBusinessDevelopers(),
        this._fetchInvoicesStatuses(),
        this._getAllProjects(),
        this._fetchInvoicesTypes(),
        this._fetchExpensesStatuses(),
        this._fetchExpensesCategories()
      ])
        .then(() => {
          this._setAllOptionsFilter()
        })
    },
    async _fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async _fetchBusinessDevelopers () {
      return this.$api.businessDevelopers.getBusinessDevelopers()
    },
    async _fetchInvoicesStatuses () {
      return this.$api.finances.getInvoicesStatuses()
    },
    async _getAllProjects () {
      await this.$api.projects.getProjects()
    },
    async _fetchInvoicesTypes () {
      return this.$api.finances.getInvoicesTypes()
    },
    async _fetchExpensesStatuses () {
      return this.$api.expenses.getExpensesStatuses()
    },
    async _fetchExpensesCategories () {
      return this.$api.expenses.getExpensesCategories()
    },
    async _fetchAllPartners () {
      return this.$api.partners.getAllPartners()
    },
    _resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    _getReportsProfitAndLoss (fields) {
      const data = this._prepareDataForGetReports(fields)

      this._toggleDataPageLoading(async () => {
        await this.$api.finances.getReportsProfitAndLoss(data).then((res) => {
          this.setReportsDataTotalFromRequest(res.data)
        })

        this._resetPagination()
      })
    },
    _setDataTotalReports ({ payoutsTotal, invoicesTotal, expensesTotal, summary }) {
      this.totalReports = [
        {
          column_group: this.config.groupName.expenses,
          server_name: 'expensesTotal',
          column_name: 'Total',
          ...expensesTotal
        },
        {
          column_group: this.config.groupName.payouts,
          column_name: 'Total',
          server_name: 'payoutsTotal',
          ...payoutsTotal
        },
        {
          column_group: this.config.groupName.payments,
          column_name: 'Total',
          server_name: 'invoicesTotal',
          ...invoicesTotal
        }
      ]

      this.itemsReportsSummary = [
        {
          column_group: this.config.groupName.summary,
          column_name: '',
          server_name: 'summary',
          ...summary
        }
      ]
    },
    _prepareDataForGetReports (fields) {
      let data = {}
      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']
        if (name === 'date_from' || name === 'date_to') {
          value = this._toLocalTime(value, 'YYYY-MM')
        }

        if (Array.isArray(value)) {
          value = value.map(item => {
            return {
              [fields[key].nameItem]: item.id
            }
          })
        }

        data[name] = value
      }

      return data
    },
    _setAllOptionsFilter () {
      this.mixin_filters.groups.payouts.fields.contractors.options = this._getAllUsers.sort((a, b) => a.name < b.name ? -1 : 1)
      this.mixin_filters.groups.payouts.fields.partners.options = this._getAllPartners.sort((a, b) => a.company_name < b.company_name ? -1 : 1)
      this.mixin_filters.groups.payouts.fields.payout_statuses.options = this._getStatuses
      this.mixin_filters.groups.payouts.fields.payout_statuses.value = [this._getStatuses.find(({ name }) => name === 'paid')]
      this.mixin_filters.groups.expenses.fields.expenses_users.options = this._getAllUsers
      this.mixin_filters.groups.expenses.fields.expenses_statuses.options = this._getExpensesStatuses
      this.mixin_filters.groups.expenses.fields.expenses_categories.options = this._getExpensesCategories
      this.mixin_filters.groups.invoices.fields.invoice_statuses.options = this._getStatuses
      this.mixin_filters.groups.invoices.fields.invoice_statuses.value = [this._getStatuses.find(({ name }) => name === 'paid')]
      this.mixin_filters.groups.invoices.fields.projects.options = this._getProjects
      this.mixin_filters.groups.invoices.fields.types.options = this._getInvoicesTypes
      this.mixin_filters.groups.invoices.fields.business_developers.options = this._getBusinessDevelopers
    },
    async _showRowModal (row) {
      const invoice = await this.$api.finances.getInvoice(row.id)
      this.mixin_tableRowModal.show = true
      this.mixin_tableRowModal.title = `Invoice number ${row.number}`
      this.mixin_tableRowModal.items = invoice
    }
  }
}
